var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaylistPlusIcon = function SvgPlaylistPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1M16.05 4.7a1 1 0 0 1 1 1v3.85h3.85a1 1 0 1 1 0 2h-3.85v3.85a1 1 0 1 1-2 0v-3.85H11.2a1 1 0 1 1 0-2h3.85V5.7a1 1 0 0 1 1-1M1 6.5a1 1 0 0 0 0 2h5.2a1 1 0 1 0 0-2zM1 13a1 1 0 1 0 0 2h5.2a1 1 0 1 0 0-2z"
  })));
};
export default SvgPlaylistPlusIcon;